0/**
 * 模态框组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
        <transition name="modal">
            <div class="modal-mask inmodal" role="dialog" v-show="show" :style="{height:maskH,top:pagescroll}" ref="mask">
                <div class="modal-dialog" v-bind:style="{ width: width + '%' }">
                    <transition
                            name="modal-container"
                            enter-active-class="animated bounceInDown"
                            leave-active-class="animated bounceOutUp">
                        <div class="modal-content" v-show="show">
                            <div class="modal-header">
								<button type="button" class="close" @click="closeModal"><span>&times;</span></button>
								<span class="header_span">{{bigTitleMsg}}</span>
							</div>
							<div class="modal-body">
								<slot name="bodycontent"></slot>
							</div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
</template>
<script>
    export default{
        name:'SubPage',
        data(){
        	return {
        		maskH:'',  //最外层modal-mask高度
        		pagescroll:this.scroll
        	}
        },
        props:{
        	show: Boolean,
        	bigTitleMsg: String,
        	scroll: String,
        	width: {
		      type: Number,
		      default: 90
		    }
        },
        watch: {
        	scroll: function (val) {
		      this.pagescroll = val;
		    }
        },
       	mounted(){  
       		this.scroll === 0? -10 : this.scroll;
       		this.$nextTick(function(){   			
       			const oPageH = parseInt(document.body.clientHeight);
       			this.maskH =  (oPageH - 87) + 'px';
       		})
       		
       		let that = this;
       		$(window).resize(function(){
       			if (window.outerHeight === screen.availHeight){ 
       				that.pagescroll = '-10px';
       			}
       			
       			const oPageH = parseInt(document.body.clientHeight);
       			that.maskH =  (oPageH - 87) + 'px';
       		});
       	},
        methods:{
           closeModal(){
           	  //在子组件中触发父组件中的取消事件
              this.$emit('cancel');
           }
        }
    }
    
    
</script>
<style scoped lang="scss">
    .w90pp { width: 90%;}
    .modal-mask {
        position: absolute;
        z-index: 9998;
        left: -10px;
        top:-10px;
        width: calc(100% + 20px);
        overflow: auto;
        background-color: rgba(0, 0, 0, .3);
        height:100%;
        .modal-dialog{
	    	/*height:100%;*/
	    /*	top:50%;
		    -webkit-transform:translateY(-50%);
		    -moz-transform:	translateY(-50%);
		    -ms-transform: translateY(-50%);
		    transform:translateY(-50%);*/
	    	.modal-content{
		    	height:90%;	
		    	
		    }
	    }
    }
    .sub_page_box{
    	.modal-mask{
    		.modal-dialog{
		    	top:50%;
			    -webkit-transform:translateY(-50%);
			    -moz-transform:	translateY(-50%);
			    -ms-transform: translateY(-50%);
			    transform:translateY(-50%); 
		    }
    	}
    }
    .modal-header{
		padding:0px;
	}
	.modal-body{
		padding:0px;
	}
    .modal-enter,.modal-leave-active{
       	 opacity: 0;
    }
    .modal-enter-active{
         transition:opacity .5s ease;
    }
    .modal-leave-active{
         opacity: 0;
         transition:opacity 0.5s ease;
    }
    .header_span{
    	font-size: 20px;
    }
    .inmodal .modal-header {
    	padding: 10px 20px;
    	text-align: left;
    	background: #f9f9f9;
    }
    .modal-header .close {
    	margin-top: 4px;
	}

    
</style>


// WEBPACK FOOTER //
// SubPage.vue?35416db0